import { render } from "./pb-units.vue?vue&type=template&id=9128e10c"
import script from "./pb-units.vue?vue&type=script&lang=js"
export * from "./pb-units.vue?vue&type=script&lang=js"

import "./pb-units.vue?vue&type=style&index=0&id=9128e10c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__